window.onWizzyScriptLoaded = function () {
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (payload) {
      window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers.push({
        dom: ".form-field-input.live-search-form-field",
        type: "text",
      });
      window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers.push(
        "#site-main"
      );
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
    function (payload) {
       $('header').css("z-index","700")
      var observer1 = new MutationObserver(function(mutations) {
 mutations.forEach(function(mutationRecord) {
    if($('.wizzy-search-filters-left').css('display')==='block'){
      $('header').css("z-index","0")
    
    }
    else{
       $('header').css("z-index","700")
    }
     
 });    
});

var target1 = document.getElementsByClassName('wizzy-search-filters-left')[0];
observer1.observe(target1, { attributes : true, attributeFilter : ['style'] });
      // onHoverAddToCart();
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (payload) {
      payload.forEach((product) => {
        let attributes = product.attributes;
        let productctVarient = attributes.filter(
          (v) => v.id === "product_variant_ids"
        );

        if (productctVarient.length) {
          product.varientId = productctVarient[0].values[0].value[0];
        } else {
          product.varientId = product.id;
        }

        attributes.forEach((attribute) => {
          if (attribute.id === "product_handle") {
            product.handle = attribute.values[0].value[0];
          }
          if (attribute.id === "product_sku") {
            product.sku = attribute.values[0].value[0];
          }
          if (attribute.id === "product_reviews_spr") {
            // alert("t")
            let reviews = `${attribute.values[0].value[0]}`;
            // console.log(reviews);
            const rMatch =  /<script \b[^>]*>[\s\S]*?<\/script\b[^>]*>/g
            let regexCode = reviews.match(rMatch);
            if(regexCode){
                          // console.log(reviews[0], "<+++++++++++ This is Reviews")
            // alert(t)
              
            let reviewObject = JSON.parse($(regexCode[0]).text())
            // console.log(reviewObject,reviewObject["ratingValue"])
           product.ratingValue = reviewObject["ratingValue"]
            product.reviewCount = reviewObject["reviewCount"]
            }

          }
        });

        //product.productId = product.groupId ? product.groupId : product.id
      });

      return payload;
    }
  );

  replaceTemplate("wizzy-search-results-product");
  replaceTemplate("wizzy-search-results");
  replaceTemplate("wizzy-search-wrapper");
  onHoverAddToCart();

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
    function (payload) {
      // console.log(payload);
      $(".wizzy-search-back .wizzy-icon").click();
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (payload) {
      $(".wizzy-search-form.mf-initial").removeClass("display-block");
      return payload;
    }
  );
  $(".site-header-mobile-search-button").click(function () {
    // alert("hello");
    $(".wizzy-search-form.mf-initial").addClass("display-block");
    $(".wizzy-search-modal-input input").click();
  });

  const isWizzyMobile= window.screen.width < 768;
  const wizzyDesktopSearchInput=".live-search .form-field-input.live-search-form-field";
   // const wizzyDesktopSearchInput=".live-search .form.live-search-form.form-fields-inline";
  const setAutocompleteTopLeft = ()=>{
    let searchInput= $(wizzyDesktopSearchInput);
    let offset =250;
    let topOffset = 45 ;
    let inputWidth = searchInput.width() + 54;
    let left  = [searchInput.offset().left-(offset/2)+125,'px'].join('');
    let top  = [(searchInput.offset().top - $(document).scrollTop())+topOffset ,'px'].join('');
    // let width = [inputWidth+offset,'px'].join('');
     let width = [inputWidth+54,'px'].join('');
    document.documentElement.style.setProperty('--wizzy-autocomplete-left', left);
    document.documentElement.style.setProperty('--wizzy-autocomplete-top', top);
    document.documentElement.style.setProperty('--wizzy-autocomplete-width',width );
  
  
}
  $(window).scroll(function(){
  
      if(!isWizzyMobile){
        setAutocompleteTopLeft();   
      }
  });

  $('body').on('click','.wizzy-search-input',(e)=>{

    
          if(!isWizzyMobile){
              setAutocompleteTopLeft()
          }
  });
    
  $('body').on('click','.wizzy-search-input',(e)=>{

          if(!isWizzyMobile){
              setAutocompleteTopLeft()
          }
  });
  $('body').on('keydown','.wizzy-search-input',(e)=>{
   
          if(!isWizzyMobile){
              setAutocompleteTopLeft()
          }
  });
};



$(".live-search-form").on("submit", function (e) {
  e.preventDefault();
});

$("body").on("click", ".site-header-mobile-search-button", function (event) {
  if (window.screen.width < 768)
    document.getElementById("wizzy-mobile-search").click();
});
function replaceTemplate(div) {
  let newDiv = document.getElementById(div + "-new").text;
  let oldDiv = document.getElementById(div);
  oldDiv.text = newDiv;
}

let onHoverAddToCart = () => {
   $("body").on('mouseenter', '.productgrid--item',function (event) {
  
      $(this).find(".productitem").attr("data-animation-state", "open");
      $(this)
        .find(".productitem__compare-wrapper")
        .attr("data-animation-state", "open"); 
  });

     $("body").on('mouseleave', '.productgrid--item',function (event) {
      
      $(this).find(".productitem").attr("data-animation-state", "closed");
      $(this)
        .find(".productitem__compare-wrapper")
        .attr("data-animation-state", "closed");
  });

};

$("body").on(
  "click",
  ".wizzy-search-results .quickshop-button button",
  function () {
    let element = $(this).parents(".productgrid--item");
    let url = $(element).attr("data-product-quickshop-url");
    function callQuickView(url, element) {
      $.ajax({
        type: "GET",
        url: `https://hawitools.com/${url}view=quickshop`,
        success: function (response) {
       
          $(".modal .modal-content").html(
            $(response).find(".product--outer")
          );
       

          $(".modal").addClass("modal modal--quickshop-full allow-scroll-while-locked") 
          $(".modal").css({
            "z-index": "899",
            visibility: "visible",
            opacity: "1",
            display: "block",
          });
          $(".modal .modal-inner").css({
            "z-index": "900",
            opacity: "1",
          });

          $(".modal-inner").css("margin-top","110px")
          window.Shopify.PaymentButton.init()

          $('.modal [data-rimg-template]').each((i,v)=>{
            let ele = $(v);
            let parentEle = ele.parents('.product-gallery--image-background');
            let ImgUrl= ele.attr('data-rimg-template').replaceAll('{size}',ele.attr('data-rimg-max'));
            ele.attr('src', ImgUrl);
            ele.attr('srcset', ImgUrl);
            ele.attr('data-rimg','loaded');
            parentEle.attr('data-rimg','loaded');
           
          });
        },
      });
      // console.log($(".product-gallery--navigation"))
      $(".product-gallery--navigation").removeClass("loading").addClass("loaded")
      return false;
    }
    callQuickView(url, element);
    quickViewCloseEventListener();
  }
);

function quickViewCloseEventListener(){
  $('body').on('click', '.modal-close', function(){
            $(".wizzy-modal .modal-content").empty();
          $(".modal").css({
            "z-index": "-1",
            visibility: "hidden",
            opacity: "0",
            display: "block",
          });
          $(".wizzy-modal .modal-inner").css({
            "z-index": "-1",
            opacity: "0",
          });
  
})
}



